import theme_icons from '../../icons.js';
import "../../components/tabpanels-ui-store";

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks; 
const { RichText, InnerBlocks } = wp.blockEditor; 
const { useSelect } = wp.data;

 const tabpanel = {
	title: 'Standard Tab Panel', 
	icon: theme_icons.greenheart,
    category: 'greenheart',
    parent:['rbt/tabpanels'],
    // Tabs must only be created via the parent's "Add New Tab" UI so the nav stays in sync
    supports: {
        inserter: false
    },
    //attributes
    attributes: {
        title:{
            type: 'string',
            default: ''
        },
        tabid: {
            type: 'string',
            default: ''
        },
        hasHeading: {
            type: 'boolean',
            default: true
        }

    },   

	edit({ clientId, attributes }){
		const { title, tabid, hasHeading } = attributes;

		// Active tab is set by the parent rbt/tabpanels block via the shared store
		const activeTabId = useSelect(
			(select) =>
				select("rbt/tabpanels-ui").getActiveTab(
					select("core/block-editor").getBlockRootClientId(clientId)
				),
			[clientId]
		);
		const isActive = !activeTabId || activeTabId === tabid;

		return (
            <li
                className={`clearfix q-tab-target type-text${isActive ? " active" : ""}`}
                id={tabid}
                style={{ display: isActive ? undefined : "none" }}
            >
                {hasHeading && <h3 className="tab-title">{title}</h3>}
                <div className="wysiwyg">
                    <InnerBlocks renderAppender={isActive ? InnerBlocks.DefaultBlockAppender : false} />
                </div>
            </li>
		);
	},
	save({attributes}) {
		const { title, tabid, hasHeading } = attributes;

		return (
            <li
                data-control-target={tabid}
                className="clearfix q-tab-target type-text"
                id={tabid}
                role="tabpanel"
                tabIndex="0"
                aria-labelledby={hasHeading ? "ctrl-" + tabid : undefined}
                aria-label={!hasHeading ? title : undefined}
            >
                {hasHeading && <h3 className="tab-title">{title}</h3>}
                <div className="tab-content">
                    <InnerBlocks.Content />
                </div>
            </li>
		)
	},
	deprecated: [
        // v1: before the heading toggle and ARIA attributes
        {
            attributes: {
                title:{
                    type: 'string',
                    default: ''
                },
                tabid: {
                    type: 'string',
                    default: ''
                }
            },
            migrate(attributes) {
                return { ...attributes, hasHeading: true };
            },
            save({attributes}) {
                const { title, tabid } = attributes;

                return (
                    <li data-control-target={tabid} className="clearfix q-tab-target type-text" id={tabid}>
                        <h3 className="tab-title">{title}</h3>
                        <div className="tab-content">
                            <InnerBlocks.Content />
                        </div>
                    </li>
                )
            }
        }
    ]
};
registerBlockType('rbt/tabpanel', tabpanel);
export default tabpanel;
